module.exports = __webpack_public_path__ + "bde48ba7cbf718ad207f568cdf900bd0.jpg";